import React, {useEffect, useState} from 'react';
import {Button, Form, Input, message} from "antd";
import './index.css'
import {sendVeriCodeToEmail, sendVeriCodeToPhone, updateEmail} from "../../../api/user";
import {useDispatch, useSelector} from 'react-redux';
import {setAuthId} from "../../../store/modules/user";
//设置邮箱
const SettingEmailApp =(props)=>{
    //父组件传输
    const {handleOk,handleCloseModel} = props
    //手机号/邮箱 0-手机号 1-邮箱
    const [resIndex,setResIndex] = useState(0)
    //验证码
    const [count, setCount] = useState(0);
    const [newCount, setNewCount] = useState(0);
    //用户信息  根据用户信息的手机号和邮箱来做限制
    const {userInfo} = useSelector(state=>state.user)
    const {avatar,email,phone,username}=userInfo

    useEffect(()=>{
        //只绑定邮箱情况下默认邮箱 修改
        if(!phone&&email){
            setResIndex(1)
            form.setFieldValue('old_phone_or_email',email)
        }else if(phone){
            //只要有手机号 就默认手机号返填
            form.setFieldValue('old_phone_or_email',phone)
        }
    },[])
    const handleSetResIndex = (i)=>{
        if(i===0&&!phone){
            message.warning('您还未绑定手机号！')
            return false
        }
        if(i===1&&!email){
            message.warning('您还未绑定邮箱！')
            return false
        }
        if(i===0) form.setFieldValue('old_phone_or_email',phone)
        if(i===1) form.setFieldValue('old_phone_or_email',email)
        setResIndex(i)
    }
    //form组件
    const dispatch = useDispatch()
    const [form] = Form.useForm();
    const onFinish = (values) => {
        updateEmail(values).then(res=>{
            if(res.code === 200){
                message.success('修改成功');
                dispatch(setAuthId(res.data['auth-id']))
                handleOk()
            }
        })
    };
    //校验失败
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    //重置内容
    const formReset = ()=>{
        form.resetFields()
    }

    //新绑定手机操作
    const handleSendNewCode=()=>{
        let new_email = form.getFieldsValue()['new_email']
        if(!new_email){
            message.error('请先输入正确的邮箱再尝试获取验证码')
            return false
        }
        if(
            !(new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, 'g')).test(new_email)&&
            !(new RegExp(/^1\d{10}$/, 'g')).test(new_email)
        ){
            message.error('请先输入正确的手机号/邮箱再尝试获取验证码')
            return false
        }
        handleNewVerCode()
        sendVeriCodeToEmail({phone_or_email:new_email}).then(res=>{
            if(res.code===200){
                message.success('验证码已发送')
            }
        })
    }
    useEffect(() => {
        if (newCount !== 0) {
            setTimeout(()=>{
                let counter = newCount
                counter--
                setNewCount(counter);
            },1000)
        }
    }, [newCount]);
    const handleNewVerCode = ()=>{
        let counter = 60; // 倒计时60秒
        setNewCount(counter);
    }

    //原绑定手机操作
    //发送验证码
    const handleSendCode = ()=>{
        let old_phone_or_email = form.getFieldsValue()['old_phone_or_email']
        if(!old_phone_or_email){
            message.error('请先输入正确的手机号/邮箱再尝试获取验证码')
            return false
        }
        if(
            !(new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, 'g')).test(old_phone_or_email)&&
            !(new RegExp(/^1\d{10}$/, 'g')).test(old_phone_or_email)
        ){
            message.error('请先输入正确的手机号/邮箱再尝试获取验证码')
            return false
        }
        console.log(old_phone_or_email)
        handleVerCode()
        if(resIndex===0){
            sendVeriCodeToPhone({phone_or_email:old_phone_or_email}).then(res=>{
                if(res.code===200){
                    message.success('验证码已发送')
                }
            })
        }else{
            sendVeriCodeToEmail({phone_or_email:old_phone_or_email}).then(res=>{
                if(res.code===200){
                    message.success('验证码已发送')
                }
            })
        }
    }
    useEffect(() => {
        if (count !== 0) {
            setTimeout(()=>{
                let counter = count
                counter--
                setCount(counter);
            },1000)
        }
    }, [count]);
    const handleVerCode = ()=>{
        let counter = 60; // 倒计时60秒
        setCount(counter);
    }

    return (
        <div className="SettingUsernameApp">
            <Form onFinish={onFinish} onFinishFailed={onFinishFailed} form={form}>
                <div className='fL'>设置新邮箱</div>
                <div>
                    <Form.Item label="" name="new_email"
                               rules={[
                                   {
                                       required: true,
                                       message: '请输邮箱',
                                   },{
                                       pattern: new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, 'g'),
                                       message: '请输入正确的邮箱'
                                   }
                               ]}
                    >
                        <Input placeholder="暂时仅支持国内邮箱，如qq,163等" size="large"/>
                    </Form.Item>
                </div>
                <div className='fL'>验证新邮箱</div>
                <div className='dp'>
                    <Form.Item label="" name="new_veri_code"
                               rules={[
                                   {
                                       required: true,
                                       message: '请输入验证码',
                                   }
                               ]}
                    >
                        <Input placeholder="验证码" size="large" className='widthSmall'/>
                    </Form.Item>
                    <Button disabled={newCount!==0} size="large" className='sbtn selfBtn btn2' onClick={handleSendNewCode}>{newCount===0?'发送验证码':newCount}</Button>
                </div>
                <div className='fL mode'>
                    <span onClick={()=>handleSetResIndex(0)} className={resIndex===1?'c':''}>原绑定手机号</span>
                    <font onClick={()=>handleSetResIndex(1)} className={resIndex===0?'c':''}>原绑定邮箱</font>
                </div>
                {
                    resIndex===0?
                        <Form.Item label="" name="old_phone_or_email"
                                   rules={[
                                       {
                                           required: true,
                                           message: '请输入手机号',
                                       },{
                                           pattern: new RegExp(/^1\d{10}$/, 'g'),
                                           message: '请输入正确的手机号'
                                       }
                                   ]}
                        >
                            <Input placeholder="暂时仅支持中国大陆手机号" disabled={true} size="large"/>
                        </Form.Item>
                        :
                        <Form.Item label="" name="old_phone_or_email"
                                   rules={[
                                       {
                                           required: true,
                                           message: '请输邮箱',
                                       },{
                                           pattern: new RegExp(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, 'g'),
                                           message: '请输入正确的邮箱'
                                       }
                                   ]}
                        >
                            <Input placeholder="暂时仅支持国内邮箱，如qq,163等" disabled={true} size="large"/>
                        </Form.Item>
                }
                <div className='fL'>验证原绑定{resIndex===0?'手机号':'邮箱'}</div>
                <div className='dp'>
                    <Form.Item label="" name="old_veri_code"
                               rules={[
                                   {
                                       required: true,
                                       message: '请输入验证码',
                                   }
                               ]}
                    >
                        <Input placeholder="验证码" size="large" className='widthSmall'/>
                    </Form.Item>
                    <Button disabled={count!==0} size="large" className='sbtn selfBtn btn2' onClick={handleSendCode}>{count===0?'发送验证码':count}</Button>
                </div>
                <Form.Item>
                    <div className='textCenter'>
                        <Button className='selfBtn' htmlType="submit">
                            提交
                        </Button>
                        <Button className='selfBtn btn2' onClick={handleCloseModel}>
                            取消
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </div>
    )
}

export default SettingEmailApp
